module.exports = __webpack_public_path__ + "pdf.png?f743244b88e966aa360f9a6a0298b8b6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pdf.png
// module id = 925
// module chunks = 2